import { FOLDERS } from './folders';

// Adres <-> ekran eşlemesi:
//   /mail/inbox            /mail/inbox/123        (klasör, açık mail UID'i)
//   /mail/label/7          /mail/label/7/123      (etiket görünümü)
//   /contacts  /calendar  /bulk  /compose  /settings/signature
const FOLDER_IDS = FOLDERS.map((f) => f.id);
const PAGES = ['contacts', 'calendar', 'bulk', 'compose'];
const SETTINGS_SECTIONS = [
  'profile', 'security', 'notifications', 'signature', 'filters', 'autoreply', 'forwarding', 'blocked',
  'appearance', 'language', 'help',
];

export const mailPath = (folderId, mailId = null) => {
  const base = typeof folderId === 'string' && folderId.startsWith('label:')
    ? `/mail/label/${folderId.slice(6)}`
    : `/mail/${folderId || 'inbox'}`;
  return mailId ? `${base}/${mailId}` : base;
};
export const settingsPath = (section) => `/settings/${section || 'profile'}`;
export const pagePath = (page) => `/${page}`;

const isUid = (value) => /^\d{1,12}$/.test(value || '');

// `canonical`: adres tanınmıyorsa gidilecek kurallı adres (yoksa adres olduğu gibi geçerli)
export const parseRoute = (pathname) => {
  const parts = (pathname || '/').split('/').filter(Boolean);
  const [head, a, b] = parts;
  const clean = `/${parts.join('/')}`;
  const mail = (folder, mailId) => {
    const normalized = mailPath(folder, mailId);
    return { page: 'mail', folder, mailId, section: 'profile', canonical: normalized === clean ? null : normalized };
  };
  const inbox = { page: 'mail', folder: 'inbox', mailId: null, section: 'profile', canonical: mailPath('inbox') };

  if (!head || head === 'mail' && !a) return inbox;
  if (head === 'mail') {
    if (a === 'label') {
      if (!/^\d{1,9}$/.test(b || '')) return inbox;
      return mail(`label:${b}`, isUid(parts[3]) ? parts[3] : null);
    }
    if (FOLDER_IDS.includes(a)) return mail(a, isUid(b) ? b : null);
    return inbox;
  }
  if (head === 'settings') {
    const section = SETTINGS_SECTIONS.includes(a) ? a : 'profile';
    return { page: 'settings', folder: 'inbox', mailId: null, section, canonical: a === section ? null : settingsPath(section) };
  }
  if (PAGES.includes(head)) return { page: head, folder: 'inbox', mailId: null, section: 'profile', canonical: null };
  return inbox;
};
